import { useState } from "react";

export const ProfPortrait = ({ className = "", testid = "prof-portrait", priority = false }) => {
  const [error, setError] = useState(false);

  if (error) {
    return (
      <div
        data-testid={testid}
        className={`relative flex items-center justify-center overflow-hidden bg-[#10392C] ${className}`}
      >
        <div className="absolute inset-0 opacity-[0.06]" style={{ backgroundImage: "radial-gradient(circle at 30% 20%, #E8F1EC 0%, transparent 55%)" }} />
        <div className="relative px-6 text-center">
          <p className="font-serif text-6xl font-semibold text-[#E8F1EC]/90 sm:text-7xl">CET</p>
          <div className="mx-auto mt-4 h-px w-16 bg-[#2E6B50]" />
          <p className="mt-4 text-[11px] uppercase tracking-[0.3em] text-[#E8F1EC]/45">
            Ritratto fotografico
            <br />
            in fase di inserimento
          </p>
        </div>
      </div>
    );
  }

  return (
    <img
      data-testid={testid}
      src="/images/prof-traverso.jpg"
      alt="Professor Carlo Enrico Traverso"
      onError={() => setError(true)}
      loading={priority ? "eager" : "lazy"}
      className={`object-cover ${className}`}
    />
  );
};
